import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

export const BeneficiaryValuesBox = styled.div`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: ${COLORS.greyLight};
  padding-bottom: 16px;
  .header {
    padding: 16px;
    border-radius: 4px;
    text-align: center;
    color: ${COLORS.whiteBase};
    background-color: ${COLORS.ctaPrimary};
  }
  &.header-grey {
    background-color: ${COLORS.greyLightest};
    .header {
      color: ${COLORS.blackBase};
      background-color: ${COLORS.grayLight};
    }
  }
  .vertical-container {
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-gap: 10px;
    .line {
      width: 2px;
      height: 100%;
      justify-self: center;
      background-color: ${COLORS.blackPure};
    }
  }
  .content,
  .content-wrapper {
    padding-top: 24px;
    padding-bottom: 16px;
    padding-left: 24px;
    padding-right: 24px;
    input {
      max-width: 88px;
      margin-left: 18px;
    }
    .first-column {
      padding-right: 24px;
    }
    .second-column {
      justify-self: end;
      text-align: right;
      .field-margin-top {
        margin-top: 7px;
      }
    }
    .no-result {
      margin: auto;
      max-width: 196px;
      text-align: center;
    }
    .no-result-text {
      margin-top: 14px;
    }
    .content-row {
      margin-bottom: 4px;
    }
  }
  .content {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
  }
  .clear {
    padding-left: 24px;
    padding-right: 24px;
    cursor: pointer;
    text-align: center;
    color: ${COLORS.ctaPrimary};
  }
  .error-text {
    margin-bottom: 10px;
  }
`;

export const ErrorText = styled(TrueImpactText)`
  padding-top: 16px;
  padding-bottom: 0;
  padding-left: 24px;
  padding-right: 24px;
  text-align: center;
  color: ${COLORS.critical};
`;

interface BeneficiaryMultiValuesProps {
  title: string;
  errorMessage?: string;
  leftSide: JSX.Element | JSX.Element[] | React.ReactNode;
  rightSide: BeneficiaryMultiValuesProps['leftSide'];
  onReset: () => unknown;
}

const BeneficiaryMultiValues: React.FC<BeneficiaryMultiValuesProps> = ({
  title,
  errorMessage,
  leftSide,
  rightSide,
  onReset,
}) => {
  return (
    <BeneficiaryValuesBox>
      <div className="header">{title}</div>
      {errorMessage && (
        <ErrorText variant="body-small">{errorMessage}</ErrorText>
      )}
      <div className="content">
        <div className="first-column">{leftSide}</div>
        <div className="vertical-container">
          <div className="line"></div>
          <TrueImpactText variant="body-bold">Or</TrueImpactText>
          <div className="line"></div>
        </div>
        <div className="second-column">{rightSide}</div>
      </div>
      <TrueImpactText variant="body-small" className="clear" onClick={onReset}>
        Clear all percentages
      </TrueImpactText>
    </BeneficiaryValuesBox>
  );
};

export default BeneficiaryMultiValues;
